export const ecomAddToCart = 'ecomAddToCart';
export const ecomRemoveFromCart = 'ecomRemoveFromCart';
export const ecomProductDetail = 'ecomProductDetail';
export const ecomProductClick = 'ecomProductClick';
export const ecomPurchase = 'ecomPurchase';

export function pushToDatalayer(data) {
  switch (data.event) {
    case ecomProductDetail:
      productDetailEvent(data);
      break;
    case ecomProductClick:
      productClickEvent(data);
      break;
    case ecomProductDetail:
      productDetailEvent(data);
      break;
    case ecomPurchase:
      purchaseEvent(data);
      break;
    case ecomAddToCart:
      addToCartEvent(data);
      break;
    case ecomRemoveFromCart:
      removeFromCartEvent(data);
      break;
    default:
      break;
  }
}

function addToCartEvent({ gtm, currency }) {
  if (gtm) {
    var product = JSON.parse(gtm);
    product.quantity = 1;

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: ecomAddToCart,
      ecommerce: {
        currencyCode: currency,
        add: {
          products: [product],
        },
      },
    });
  }
}

function removeFromCartEvent({ gtm, currency, removeAll = false }) {
  if (product) {
    var product = JSON.parse(gtm);
    if (!removeAll) product.quantity = 1;

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: ecomRemoveFromCart,
      ecommerce: {
        currencyCode: currency,
        remove: {
          products: [product],
        },
      },
    });
  }
}

function productDetailEvent({ gtm, currency }) {
  const data = {
    event: ecomProductDetail,
    ecommerce: {
      currencyCode: currency,
      detail: {
        products: [JSON.parse(gtm)],
      },
    },
  };

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(data);
}

function productClickEvent({ gtm, gtmList, currency, href }) {
  const data = {
    event: ecomProductClick,
    currencyCode: currency,
    ecommerce: {
      click: {
        actionField: { list: gtmList },
        products: [JSON.parse(gtm)],
      },
    },
    eventCallback: function () {
      document.location = href;
    },
    eventTimeout: 1 * 1000,
  };

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(data);
}

function purchaseEvent({ gtm, currency, signup }) {
  if(gtm) {
    const data = {
      event: ecomPurchase,
      newsletter: {
        type: 'purchase',
        signup: signup,
      },
      ecommerce: {
        currencyCode: currency,
        purchase: JSON.parse(gtm),
      },
    };

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(data);
  }
}
